import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";

import styles from "./seekAssetCard.module.scss";
import cx from "classnames";
import _ from "lodash";

import DefaultAssetIcon from "images/default_asset.jpg";
import { trackAdoptionMetricsForAssetDetailViewedEvent } from "actions/adoption";
import FileService from "services/file.service";

const webAppUrl = process.env.REACT_APP_WEBAPP_URL;

export default function AssetCard(props){

    const dispatch = useDispatch();

    const url = `${webAppUrl}/assets/${_.get(props.asset, "id")}`;
    const icon = _.get(props.asset, "icon.thumbnail") || DefaultAssetIcon;
    const name = _.get(props.asset, "name");
    var extension = _.get(props.asset, "metadata.extension");
    const contentType = _.get(props.asset, "metadata.content_type");
    const isShare = _.get(props.asset, "settings.share");

    var link = false;
  

    if (contentType.endsWith("url")) {
      link = true;
    }

    const handleClick = () => {
      dispatch(trackAdoptionMetricsForAssetDetailViewedEvent("Asset Detail Viewed", "Seek", FileService.fileType(_.get(props.asset, "metadata"))));
    }

    return (
      <div className={styles.asset}>
   
        {!isShare &&  <div className={styles.internalIconContainer}>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">internal use only</Tooltip>}
            >
              <i className={cx(styles.iconLock, "paperflite-lock")}></i>
            </OverlayTrigger>
          </div>}


        <a className={styles.iconWrapper} href={url} target="_blank" onClick={() => handleClick()}>
          <img className={cx(styles.icon, styles.trial)} src={icon} alt="img" />
        </a>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip className={styles.toolTip} id="tooltip-name">{name}</Tooltip>}
        >
          <div className={styles.name}>
            {name}
          </div>
        </OverlayTrigger>
      </div>
    );
  }